import moment from 'moment';
import _ from 'lodash';

import { Email } from 'meteor/email';
import { Meteor } from 'meteor/meteor';
import { Mongo } from 'meteor/mongo';
import { SimpleSchema } from 'meteor/aldeed:simple-schema';

import { Addresses } from './addresses.js';
import { BaseSchema } from '../baseSchema';
import { Flights } from '../flights/flights.js';
import { FlightsType } from '../flights-type/flights-type.js';
import { Options } from '../flights-type/options.js';
import { Promotions } from '../flights-type/promotions.js';

import { Passengers } from './passengers.js';
import { Payments } from './payments.js';
import { HTTP } from 'meteor/http';

import { Base64 } from 'meteor/base64';
import { getBilletID } from './methods';

export const Reservations = new Mongo.Collection('reservations');
import axios from 'axios';

Reservations.attachRoles('reservations');

export const Reservation = new SimpleSchema([{
	id: {
		type: Number,
		label: "N° Réservation",
		autoValue: function() {
			if (this.isInsert) {
				let last = Reservations.find({}, {sort: {id: -1}, limit: 1}).fetch();
				if(!last[0])
				return 1;
				return parseInt(last[0].id + 1);
			} else {
				this.unset();  // Prevent user from supplying their own value
			}
		}
	},
	id_facture: {
		type: String,
		label: "N° Facture",
		optional: true,
		autoValue: function() {
			let d = new Date();
			let total = parseInt(Reservations.find({id_facture: {$regex: ".*" + d.getFullYear().toString().slice(-2) + "-.*"}}).fetch().length) + 1;

			let numerotation = '';
			for(let i = 0; i < (4 - total.toString().length); i++) {
				numerotation += '0';
			}

			if(!this.field("id_facture").value && this.field("state").value < 3) {
				return d.getFullYear().toString().slice(-2) + '-' + numerotation + total;
			}
			else {
				return this.field("id_facture").value;
			}
		}
	},
	id_billet: {
		type: String,
		label: "N° Billet",
		optional: true,
		autoValue: function() {
			if(!this.field("id_billet").value && this.field("state").value == 3) {
				return getBilletID.call({});
			}
			else {
				return this.field("id_billet").value;
			}
		}
	},
	id_internet: {
		type: String,
		label: "Identifiant internet",
		optional: true
	},
	subscriber: {
		type: Addresses,
		label: "information d'achat"
	},
	delivery: {
		type: Addresses,
		label: "information de livraison"
	},
	passengers: {
		type: [Passengers],
		label: "passagers"
	},
	selectedFlight: {
		type: Flights,
		label: "vol"
	},
	place: {
		type: String,
		label: "Zone d'envol"
	},
	options: {
		type: [Options],
		label: "Options",
		optional: true
	},
	promotions: {
		type: [String],
		label: "Promotions",
		optional: true
	},
	period: {
		type: String,
		label: "Période",
		optional: true
	},
	periodTime: {
		type: String,
		label: "Période Matin/Soir",
		optional: true
	},
	author: {
		type: String,
		label: "Auteur",
		optional: true
	},
	state: {
		type: Number,
		label: "Status"
	},
	payment: {
		type: Number,
		label: "Mode de paiement"
	},
	billAt: {
		type: String,
		label: "Facturé le",
		optional: true,
		autoValue: function() {
			if(!this.field("billAt").value && this.field("state").value >= 3)
			return moment().format('DD/MM/YYYY');
			else
			return this.field("billAt").value;
		}
	},
	price: {
		type: String,
		label: "prix"
	},
	solde: {
		type: String,
		label: "Solde restant",
		optional: true,
	},
	infoPayment: {
		type: String,
		label: "Information sur le paiement",
		optional: true
	},
	infoReservation: {
		type: String,
		label: "Information sur la réservation",
		optional: true
	},
	linkReservation: {
		type: String,
		label: "Billets liés",
		optional: true
	},
	infoClient: {
		type: String,
		label: "Information du client",
		optional: true
	},
	livraisonType: {
		type: Number,
		label: "Billet ou Billet + Facture ?",
		optional: true
	},
	searchName: {
		type: String,
		optional: true,
		label: "Recherche par nom/prenom"
	},
	scheduledAt: {
		type: Date,
		optional: true
	},
	history: {
		type: [Object],
		defaultValue: []
	},
	"history.$": {
		type: Object,
		blackbox: true
	},
	userId: {
		type: String,
		label: "Auteur",
		optional: true
	},
	freeFlights: {
		type: Boolean,
		label: "Vol gratuit",
		optional: true
	},
	groupBill: {
		type: Boolean,
		label: "Facturé en groupe",
		optional: true
	},
	pendingSMS: {
		type: Boolean,
		optional: true,
		label: "SMS en attente"
	},
	impression: {
		type: Boolean,
		optional: true,
		label: "Ne pas envoyer le billet"
	},
	mailSending: {
		type: Number,
		optional: true,
		defaultValue: 0
	},
	flightName: {
		type: String,
		label: "Nom du vol",
		optional: true,
	},
	codePromoName: {
		label: "Code Promo Nom",
		type: String,
		optional: true,
	},
	codePromoType: {
		label: "Code Promo Type",
		type: String,
		optional: true,
	},
	codePromoReduction: {
		label: "Code Promo Reduction",
		type: String,
		optional: true,
	},
	color: {
		label: "Couleur",
		type: String,
		optional: true
	},
	expireAt: {
		label: "Expire en",
		type: String,
		optional: true
	}
}, BaseSchema]);

Reservations.attachSchema(Reservation);

// Dbs methods :

Meteor.methods({
	'reservations.insert'(attributes) {
		let subscriber = Addresses.insert(attributes.subscriber);
		let delivery = Addresses.insert(attributes.delivery);

		attributes.subscriber = subscriber;
		attributes.delivery = delivery;

		Reservations.insert(attributes);
	},
	'reservations.update'({_id, attributes}) {
		Reservations.update(_id, { "$set": attributes });
	},
	sendEmail: function (to, from, subject, html) {
		Email.send({
			to: to,
			from: from,
			subject: subject,
			html: html
		});
	},
	sendEmailV2: function(email, subject, templateId, data) {

		if (Meteor.isServer) {

			console.log(data);

			const btoa = (text) => {
				return Buffer.from(text, 'binary').toString('base64');
			};

			let basicAuth = 'Basic ' + btoa(process.env.MJ_APIKEY_PUBLIC + ':' + process.env.MJ_APIKEY_PRIVATE);

			console.log(basicAuth);
			axios.post('https://api.mailjet.com/v3.1/send', {
				"Messages": [
					{
							"From": {
									"Email": "noreply@montgolfieres.fr",
									"Name": "Anjou Nantes Montgolfieres"
							},
							"To": [
									{
											"Email": email,
									}
							],
							"Subject": subject,
					"TemplateID": templateId,
					"TemplateLanguage": true,
					"Variables" : data
			}]
			}, {
				headers: { 'Authorization': + basicAuth },
				auth: {
					username: process.env.MJ_APIKEY_PUBLIC,
					password: process.env.MJ_APIKEY_PRIVATE
				}
			}).then(function(response) {
				console.log('Email sended !');
			}).catch(function(error) {
				console.log('Error on Authentication', error);
			});

	}

	},
});

Reservations.after.insert(function (userId, doc) {
	if(doc.freeFlights) {
		let freeFlights = Meteor.user().profile.freeFlights - doc.passengers.length;
		Meteor.users.update(Meteor.user()._id, {"$set": {'profile.freeFlights': freeFlights}});
	}

	if(doc.userId) {
		/*let d = new Date();
		let last = Reservations.find({id_billet: {$regex: ".*" + d.getFullYear().toString().slice(-2) + "-.*"}}, {sort: {id_billet: -1}}).fetch();

		let total = parseInt(last[0].id_billet.split('-')[1]) + 1;

		let numerotation = '';
		for(let i = 0; i < (4 - total.toString().length); i++) {
		numerotation += '0';
	}*/

	Reservations.update(doc._id, { "$set": { 'id_billet': getBilletID.call({}), 'state': 5 } });

}

});

// Helpers :
Reservations.helpers({
	getSolde() {
		let payments = Payments.find({reservation: this._id}).fetch();
		let solde = this.getPrice();

		_.map(payments, function(payment) { solde -= parseFloat(payment.montant); });

		if(solde != this.solde) {
			Reservations.update(this._id, {'$set': {solde: solde}});
		}

		return solde;
	},
	getPrice() {
		let passengers = [];
		let price = 0;
		_.each(this.passengers, (passenger) => {
			let data = Passengers.findOne({_id: passenger});
			if(data)
			price += parseInt(data.price);
		});

		if(this.freeFlights)
		return 0;

		return price;
	},
	getCancelTime() {
		let counter = 0;
		_.each(this.history, (history) => {
			if(history.type == 'cancelled')
			counter++;
		});

		return counter;
	},
	getLastCancelTime() {
		let target = 'null';
		_.each(this.history, (history) => {
			if(history.type == 'cancelled') {
				target = history.scheduledAt;
			}
		});

		return target;
	},
	getSubscriber() {
		return Addresses.findOne({_id: this.subscriber});
	},
	getDelivery() {
		return Addresses.findOne({_id: this.delivery});
	},
	getPassengers() {
		let passengers = [];
		_.each(this.passengers, (passenger) => {
			let data = Passengers.findOne({_id: passenger});
			if(data) {
				data.AEM = data.getAEM();
				passengers.push(data);
			}
		});
		return passengers;
	},
	getFlightType() {
		return FlightsType.findOne({_id: this.selectedFlight});
	},
	getFlightColor() {
		return FlightsType.findOne({_id: this.selectedFlight}).color;
	},
	getOptions() {
		let options = [];
		_.each(this.options, (option) => {
			options.push(Options.findOne({_id: option}));
		});
		return options;
	},
	getPromotions() {
		let promotions = [];
		_.each(this.promotions, (promotion) => {
			promotions.push(Promotions.findOne({_id: promotion}));
		});
		return promotions;
	},
	getPlace() {
		if(this.place == "anjou")
		return "Site d'envol Anjou";
		else
		return "Site d'envol de Nantes";
	},
	getFlightName() {
		if(!this.flightName && this.getFlightType()) {
			Reservations.update(this._id, {'$set': {flightName: this.getFlightType().title}});
		}

		if(!this.flightName && !this.getFlightType()) {
			Reservations.update(this._id, {'$set': {flightName: '-'}});
		}

		return this.flightName;
	},
	getPeriod() {

		//return this.period;

		if(this.period == "Libre date" || this.period == "Semaine uniquement") {
			return this.period;
		}

		if(this.period == "Tous les jours") {
			return "Libre date";
		}

		if(this.period == "aucune" || this.period == "Aucune restriction")
		return "Libre date";
		else
		return "Semaine uniquement";
	},
	getPeriodTime() {

		let period = '';

		if(!this.periodTime)
		period = this.period;
		else
		period = this.periodTime;

		if(period == "morning")
		return "Matin";
		else
		return "Soir";
	},
	getState() {
		if(this.state == 2)
		return "En attente de paiement";
		if(this.state == 3)
		return "Facturé";
		if(this.state == 4)
		return "Confirmée";
		if(this.state == 5)
		return "Expédiée";
		if(this.state == 6)
		return "Volée";
	},
	getPayment() {
		if(this.payment == 0)
		return "En attente de paiement";
		if(this.payment == 1)
		return "En liquide";
		if(this.payment == 2)
		return "Par virement";
		if(this.payment == 3)
		return "En CB";
	},
	getAuthor() {
		Meteor.subscribe('users');
		let user = Meteor.users.findOne(this.userId);

		if(!user)
		return '-';

		return user.profile.firstName + ' ' + user.profile.lastName;
	},
	getFlight() {
		return Flights.findOne({reservationIds: {$in: [this._id]}, date: this.scheduledAt});
	},
	totalWeight() {
		return _.reduce(Passengers.find({_id: { $in: this.passengers } }).fetch(), (weight, passenger) => {
			return weight + parseInt(passenger.weight) + 4;
		}, 0);
	},
	isPartners() {
		let user = Meteor.users.findOne(this.userId);

		if(!user)
		return false;

		if(_.includes(user.roles, 'partner'))
		return true

		return false;
	},
	getPartner() {
		Meteor.subscribe('users');
		return Meteor.users.findOne(this.userId);
	},
	consume() {
		Reservations.update(this._id, {'$set': {state: 6}});

		/*let subscriber = this.getSubscriber();

		let passengers = [];
		_.each(this.getPassengers(), (passenger) => {
		passengers.push({
		"name": this.flightName .
	});
});

let json_params = {
"api_token": "iptSvl4EZP15z1UdGfaD/2pulse",
"invoice": {
"kind":"vat",
"number": null,
"seller_name": "Anjou - Nantes Montgolfieres",
"buyer_name": subscriber.name,
"buyer_city": subscriber.city,
"positions":[
{"name":"Produkt A1", "tax":23, "total_price_gross":10.23, "quantity":1},
{"name":"Produkt A2", "tax":0, "total_price_gross":50, "quantity":2}
]
}}
//alert(JSON.stringify(json_params))
let endpoint = 'https://2pulse.vosfactures.fr/invoices.json'

// Création de la facture :
HTTP.post(endpoint, {
data: json_params,
dataType: 'json',
}, (error, result) => {
result = JSON.parse(result.content);
console.log('result', result);
});*/

},
sendBillet() {
	let data = {
		'reservation': this,
		'period': this.getPeriod(),
		'place': this.getPlace(),
		'flight': this.getFlightType(),
		'passengers': this.getPassengers(),
		'subscriber': this.getSubscriber(),
		'delivery': this.getDelivery(),
		'password': moment(this.createdAt).format('X').slice(-4)
	};

	data.reservation.expireAt = moment(data.reservation.billAt, 'DD-MM-YYYY').add(2, 'years').format('DD/MM/YYYY');


	HTTP.post('https://montgolfieres-pdf.amaia.at/scripts/pdf?type=billet', {
		data,
		strictSSL: false
	}, (error, result) => {
		let aerostack_url = (process.env.NODE_ENV == 'production') ? 'https://resa.montgolfieres.fr/sendBillet' : 'http://localhost:4000/sendBillet';
		HTTP.get(aerostack_url + '?id=' + result.data.id + '&email=' + this.getSubscriber().email + '&id_billet=' + this.id_billet + '&password=' + moment(this.createdAt).format('X').slice(-4), {}, (error, result) => {
		});

	});


},
getEmail() {

	let email = null;

	//Vérification email des passagers :
	_.each(this.getPassengers(), (passenger) => {
		if(passenger.email) {
			email = passenger.email;
		}
	});

	if(email == null && this.getSubscriber()) {
		email = this.getSubscriber().email;
	}

	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	if(re.test(email))
	return email;

	return false;
},
sendPassengersEmail(infos) {


	_.each(this.passengers, (passenger) => {
		let data = Passengers.findOne({_id: passenger});
		if(data) {
			if(data.email) {
				console.log('passenger has email', data.email);
				Meteor.call('sendEmailV2', data.email, 'Plannification de votre vol', 4011951, {'infos': infos} );
			}
		}
	});


},
sendCancelDateEmail() {

}


});



/** WEBPACK FOOTER **
 ** ./src/universal/collections/reservations/reservations.js
 **/